import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions, ChartType, Color, LabelItem } from 'chart.js';
import { UserStepService } from 'src/app/services/user-step.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-weekly-report-chart-steps',
  templateUrl: './weekly-report-chart-steps.component.html',
  styleUrls: ['./weekly-report-chart-steps.component.scss']
})
export class WeeklyReportChartStepsComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Days Hit',
        fill: true,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:1,
        backgroundColor: '#01E5BE',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#fff',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 7,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "DAYS HIT STEP TARGET",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = false;


  constructor(private userStepService: UserStepService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      this.lineChartData.labels?.push(
        weekNo+1
      );

      var daysHit = this.userStepService.getDaysHit(weekData);
      this.lineChartData.datasets[0].data.push(daysHit);
    });
  }


}
